import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { filters, headers } from "./config";


const UserList = () => {
  return (
    <Table tableId="users" title="User" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="display_name" idKey="user_id" fieldsToSearch={['Display Name', 'Email']} trash={false} />
  );
};

export default UserList;